import PropTypes from "prop-types";
import React from "react";
import { Route } from "react-router-dom";
import {
  repositories,
  manageRepository,
  addRepositoryItem,
  manageRepositoryItem,
  addRepositoryItemVersion,
  showRepositoryItemVersion,
  repositoryItemAssociatedFiles,
  repositoryItemAssociatedCourses
} from "../../routes/AdminRoutes";
import AllRepositories from "../../views/Content/Repository/AllRepositories";
import ManageRepository from "../../views/Content/Repository/ManageRepository/ManageRepository";
import AddRepositoryItemVersion from "../../views/Content/Repository/ManageRepository/AddRepositoryItemVersion";
import AddRepositoryItem from "../../views/Content/Repository/ManageRepository/AddRepositoryItem";
import ManageRepositoryItem from "../../views/Content/Repository/ManageRepository/ManageRepositoryItem";
import ShowRepositoryItemVersion from "../../views/Content/Repository/ManageRepository/ShowRepositoryItemVersion";
import AssociatedCourses from "../../views/Content/Repository/ManageRepository/AssociatedCourses";
import AssociatedFiles from "../../views/Content/Repository/ManageRepository/AssociatedFiles";
import { fetchUser } from "../../redux/actions/userActions";
import { connect } from "react-redux";

export function AdminContentRepositories(props) {
  const userPermissions = props.userState.user.permissions;
  return (
    <>
      {userPermissions && userPermissions.allowRepository && (
        <>
          <Route exact path={repositories} component={AllRepositories} />
          <Route exact path={manageRepository} component={ManageRepository} />
          <Route exact path={addRepositoryItem} component={AddRepositoryItem} />
          <Route
            exact
            path={manageRepositoryItem}
            component={ManageRepositoryItem}
          />
          <Route
            exact
            path={addRepositoryItemVersion}
            component={AddRepositoryItemVersion}
          />
          <Route
            exact
            path={repositoryItemAssociatedFiles}
            component={AssociatedFiles}
          />
          <Route
            exact
            path={repositoryItemAssociatedCourses}
            component={AssociatedCourses}
          />
          <Route
            exact
            path={showRepositoryItemVersion}
            component={ShowRepositoryItemVersion}
          />
        </>
      )}
    </>
  );
}

const mapStateToProps = state => ({
  userState: state.userState
});

const mapDispatchToProps = {
  fetchUser
};

AdminContentRepositories.propTypes = {
  match: PropTypes.any
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminContentRepositories);
